export class UserProfileModel {
    id: number;
    uId: string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNo: string;
    userPwd: string;
    userTypeCD: number;
    gender: string;
    countryName: string;
    stateName: string;
    cityName: string;
    countryId: number;
    cityId: number;
    isOnline: boolean;
    userStatusCD: number;
    subscribePromoOffers: boolean;
    userClassCD: number;
    roleId: number;
    referralCode: string;
    referredBy: string;
    loginFailedAttempt: number;
    emailOTP: string;
    mobileOTP: string;
    role: string;
    otpExpiryTime: string;
    resendOTPAttempt: number;
    resetPasswordAttempt: number;
    resetPasswordAttemptDate: string;
    isEmailVerified: boolean;
    isMobileVerified: boolean;
    countryUId: string;
    userTypeCDUId: string;
    cityUId: string;
    stateUId: string;
    userStatusCDUId: string;
    userClassCDUId: string;
    userStatusCDName: string;
    fullName: string;
    profilePicURL: string;
    genderCDName: string;
}